const Mobile = () => {
  return (
    <div>
      
    </div>
  )
}

export default Mobile